import type { Problem, MoveResult } from '../../types';
import './ProblemCard.css';

interface ProblemCardProps {
  problem: Problem;
  result: MoveResult | null;
  hintLevel: number;
  onHint: () => void;
  onShowSolution: () => void;
  onNext: () => void;
}

export function ProblemCard({ problem, result, hintLevel, onHint, onShowSolution, onNext }: ProblemCardProps) {
  const difficultyLabel = (d: number) => {
    if (d <= 3) return 'Easy';
    if (d <= 6) return 'Medium';
    return 'Hard';
  };

  const difficultyColor = (d: number) => {
    if (d <= 3) return '#16a34a';
    if (d <= 6) return '#d97706';
    return '#dc2626';
  };

  return (
    <div className="problem-card">
      <div className="problem-header">
        <span
          className="difficulty-badge"
          style={{ backgroundColor: difficultyColor(problem.difficulty) }}
        >
          {difficultyLabel(problem.difficulty)} ({problem.difficulty})
        </span>
        <span className="problem-source">{problem.source === 'tsumego' ? 'Tsumego' : 'GoGameGuru'}</span>
        {problem.previously_solved && <span className="solved-badge">Solved before</span>}
      </div>

      {problem.comment && (
        <p className="problem-comment">{problem.comment}</p>
      )}

      {result && (
        <div className={`result-banner ${result.correct ? 'correct' : 'wrong'}`}>
          {result.already_solved ? 'Already solved!' :
           result.solved ? 'Problem solved!' :
           result.correct ? 'Good move! Continue...' :
           'Wrong move. Try again!'}
          {result.comment && <p className="result-comment">{result.comment}</p>}
        </div>
      )}

      <div className="problem-actions">
        {!result?.solved && (
          <>
            <button onClick={onHint} className="btn btn-hint" disabled={hintLevel >= 2}>
              Hint {hintLevel > 0 ? `(${hintLevel}/2)` : ''}
            </button>
            <button onClick={onShowSolution} className="btn btn-solution">
              Show Solution
            </button>
          </>
        )}
        <button onClick={onNext} className="btn btn-next">
          Next Problem
        </button>
      </div>
    </div>
  );
}
